export default __webpack_public_path__ + "static/media/fmono_logo_no_text.f738c62a.png";